<template>
  <div id="alarm-table" class="card margin-bottom overflow-visible p-mt-1">
    <div class="card-content min-height-140">
      <div class="p-col-12 p-sm-12 p-md-12 p-lg-12">
        <!--<TabMenu :model="menuItems" />            
            <router-view />-->

        <f7-row no-gap class="p-pt-3">
          <div class="card w-100 card-table">
            <DataTable
              showGridlines
              :value="alarms"
              rowIndexVar="rowIndex"
              responsiveLayout="scroll"
              :paginator="true"
              :rows="10"
            >
              <Column
                field="ID"
                header="№"
                :sortable="false"
                :style="{ width: '50px' }"
              >
                <template #body="{ data }">
                  <div class="message-block">
                    <span>{{ data.NO }}</span>
                  </div>
                </template>
              </Column>

              <Column
                field="ID"
                header="Map"
                :sortable="false"
                :style="{ width: '50px', 'text-align': 'center' }"
              >
                <template #body="{ data }">
                  <div class="message-block">
                    <i
                      style="color: #ff0000"
                      data-icon="l"
                      :data-no="data.NO"
                      class="icon size-20"
                      @click="showAlarmOnMap(data)"
                    ></i>
                  </div>
                </template>
              </Column>

              <Column
                field="IMEI"
                header="IMEI"
                :sortable="false"
                :style="{ 'text-align': 'center' }"
              >
                <template #body="{ data }">
                  <div class="message-block">
                    <span>{{ data.IMEI }}</span>
                  </div>
                </template>
              </Column>
              <Column field="AssetName" header="Name" :sortable="false">
                <template #body="{ data }">
                  <div class="message-block">
                    <span>{{ data.AssetName }}</span>
                  </div>
                </template>
              </Column>
              <Column field="AlertType" header="Alarm type" :sortable="false">
                <template #body="{ data }">
                  <div class="message-block">
                    <span>{{ data.AlertType }}</span>
                  </div>
                </template>
              </Column>
              <Column
                field="PositionTime"
                header="Date, Time"
                :sortable="false"
              >
                <template #body="{ data }">
                  <div class="message-block">
                    <span>{{ data.PositionTime }}</span>
                  </div>
                </template>
              </Column>
              <Column
                field="ID"
                header="Action"
                :sortable="false"
                :style="{ width: '50px', 'text-align': 'center' }"
              >
                <template #body="{ data }">
                  <div class="message-block">
                    <Button
                      :data-no="data.NO"
                      label="Remove"
                      class="p-button-danger p-button-rounded"
                    />
                  </div>
                </template>
              </Column>
            </DataTable>
          </div>
        </f7-row>
      </div>
    </div>
  </div>

  <Dialog
    header="Header"
    class="alarm-popup"
    v-model:visible="isAlarmMapPopupOpened"
  >
    <template #header>
      <h3>{{ headerPopup }}</h3>
    </template>
    <f7-page class="page-alarm-popup">
      <l-map
        ref="map-popup"
        v-model="zoom"
        v-model:zoom="zoom"
        :center="posAlarm"
        class="map"
        :zoom-animation="true"
        :options="{ zoomControl: false }"
      >
        <l-tile-layer
          v-for="tileProvider in tileProviders"
          :key="tileProvider.name"
          :name="tileProvider.name"
          :visible="tileProvider.visible"
          :url="tileProvider.url"
          :subdomains="tileProvider.subdomains"
          layer-type="base"
        />

        <l-feature-group ref="markersFeatureGroup">
          <l-marker :lat-lng="posAlarm">
            <l-icon
              :icon-size="[40, 40]"
              :icon-anchor="[20, 39]"
              :icon-url="iconUrl"
            />
          </l-marker>
        </l-feature-group>
      </l-map>
    </f7-page>
  </Dialog>
</template>

<script>
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import Tooltip from "primevue/tooltip";
import { mapGetters } from "vuex";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import moment from "moment-mini";
import Dialog from "primevue/dialog";
import { getFromStorage } from "../../js/helper";
import {
  LMap,
  LIcon,
  LTileLayer,
  LMarker,
  LControlLayers,
  LPopup,
} from "@vue-leaflet/vue-leaflet";

export default {
  name: "alarm-table",

  components: {
    Dialog,
    DataTable,
    Column,
    Button,
    LMap,
    LIcon,
    LTileLayer,
    LMarker,
    LControlLayers,
    LPopup,
  },

  directives: {
    tooltip: Tooltip,
  },

  data() {
    const { t } = useI18n();
    return {
      headerPopup: "",
      posAlarm: [],
      alarms: [],
      isAlarmMapPopupOpened: false,
      iconUrl: "./static/images/pin-red.svg",
      tileProviders: [
        {
          name: "Map",
          visible: true,
          url: "https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
          subdomains: ["mt0", "mt1", "mt2", "mt3"],
        },
      ],
      map: null,
      zoom: 9,
      center: [42, 42],
    };
  },

  computed: {
    ...mapGetters(["MajorToken", "MinorToken", "IS_LOGGED_IN", "info"]),
  },

  watch: {
    // IS_LOGGED_IN(state) {
    //   if (!state) {
    //     return;
    //   }
    //   this.loadLazyData();
    // },
  },

  mounted() {
    // if (this.IS_LOGGED_IN) {
    this.isLoading = true;

    this.lazyParams = {};

    this.loadLazyData();
    //}
  },

  methods: {
    showAlarmOnMap(data) {
      this.headerPopup = data.AlertType;


      this.posAlarm =    data.PosData

      this.isAlarmMapPopupOpened = true;
    },
    dateFormat(dateStr, outFormat, inFormat) {
      return dateFormat(dateStr, outFormat, inFormat);
    },

    async loadLazyData() {
      this.isLoading = true;

      let assetListObj = await this.$store.dispatch(
        "getFromLocalStorage",
        "assetList"
      );

      const userInfo = getFromStorage("userInfo");

      let assets = Object.values(assetListObj);

      let assetIds = assets.map((val) => val.Id);

      let params = {
        MajorToken: this.info.MajorToken
          ? this.info.MajorToken
          : userInfo.MajorToken,
        MinorToken: this.info.MinorToken
          ? this.info.MinorToken
          : userInfo.MinorToken,
        DateFrom: " 2022-06-06 20:13:34", //moment
        //   .utc(self.CalendarStartDateTime.getValue()[0])
        //   .format(window.COM_TIMEFORMAT),
        DateTo: "2022-06-07 20:13:34", //moment
        //   .utc(self.CalendarEndDateTime.getValue()[0])
        //   .format(window.COM_TIMEFORMAT),
        AsIds: assetIds, //assetsEl.val(),
        AlertIds: [
          "8",
          "16777216",
          "1024",
          "33554432",
          "2097152",
          "65536",
          "32768",
          "16384",
          "128",
          "16",
          "512",
          "1048576",
          "131072",
          "4",
          "2",
          "32",
          "256",
        ], //alertsEl.val(),
      };

      let result = await this.$store.dispatch("GET_REPORT_BY_ALERT", params);

      this.alarms = result.map((el, i) => ({
        NO: i + 1,

        IMEI: el.IMEI.replace(/\s/g, ""),
        AssetName: el.AssetName,
        AlertType:  'SOS Duress', //this.getAletTypeName(el.AlertID),
        PositionTime: el.PositionTime,
        PosData: [el.Lat, el.Lng]
      }));

 

      this.isLoading = false;
    },

    getAletTypeName(type) {
      var ret = "";
      type = "" + type;
      switch (type) {
        case "2":
          ret = this.$t("REPORT_ALERT_LIST_MSG03");
          break; // SOS Duress
        case "4":
          ret = this.$t("REPORT_ALERT_LIST_MSG04");
          break; // Power Disconnect
        case "8":
          ret = this.$t("REPORT_ALERT_LIST_MSG05");
          break; // Enter Geofence
        case "16":
          ret = this.$t("REPORT_ALERT_LIST_MSG06");
          break; // Leave Geofence
        case "32":
          ret = this.$t("REPORT_ALERT_LIST_MSG07");
          break; // Speed Alert
        case "128":
          ret = this.$t("REPORT_ALERT_LIST_MSG09");
          break; // Intrusion Alert
        case "256":
          ret = this.$t("REPORT_ALERT_LIST_MSG10");
          break; // Tilt / Shock
        case "512":
          ret = this.$t("REPORT_ALERT_LIST_MSG11");
          break; // Low Battery
        case "1024":
          ret = this.$t("REPORT_ALERT_LIST_MSG12");
          break; // Geolock Alert
        case "16384":
          ret = this.$t("REPORT_ALERT_LIST_MSG16");
          break; // Impact / Crash
        case "32768":
          ret = this.$t("REPORT_ALERT_LIST_MSG17");
          break; // Ignition On
        case "65536":
          ret = this.$t("REPORT_ALERT_LIST_MSG18");
          break; // Ignition Off
        case "131072":
          ret = this.$t("REPORT_ALERT_LIST_MSG19");
          break; // Positive Input
        case "1048576":
          ret = this.$t("REPORT_ALERT_LIST_MSG22");
          break; // Negative Input
        case "2097152":
          ret = this.$t("REPORT_ALERT_LIST_MSG23");
          break; // Harsh Bracking
        case "16777216":
          ret = this.$t("REPORT_ALERT_LIST_MSG26");
          break; // Fatigue Driving
        case "33554432":
          ret = this.$t("REPORT_ALERT_LIST_MSG27");
          break; // Harsh Accelerate
      }
      return ret;
    },
    onPage(event) {
      this.lazyParams = event;
      this.loadLazyData();
    },

    copyToClipboard(text) {
      let isCopied = copyToClipboard(text);
      if (isCopied) {
        this.$toast.add({
          severity: "success",
          summary: this.$t("Success"),
          detail: this.$t("TextCopied"),
          life: 3000,
        });
      }
    },
  },
};
</script>

<style scoped>
</style>